
<script>
	import listBase from '@_system/components/base/list.vue'
	import staticIndex from './static/index.vue'
	import formIndex from './form/index.vue'
	export default {
		extends: listBase,
		name: 'paymentapplicationinvoiceIndex',
		props: {

		},
		render(h) {
			this.$slots.header = [
				<static-index ref="staticIndex" />,
				<form-index ref="formIndex" data={this.currentrow} onSuccess={this.formSubmit} />,
			]

			return listBase.render.call(this, h)
		},
		data() {
			return {
				moduleName: 'paymentapplicationinvoice',
				windowName: '模块名称',
				windowType: 'modal',
				currentrow:{},
				list_footerField:[{
					field:"purchasesum",
					toFixed:2
				},{
					field:"haswriteoffamount",
					toFixed:2
				},{
					field:"remainamount",
					toFixed:2
				}]
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			edit(row){
				this.currentrow = row
				this.$refs.formIndex.modal_show()
			},
			formSubmit(){
				this.customreload()
			},
			afterGet(){
				this.$refs.staticIndex.init()
			},
			beforeCreateGrid(formConfig, columns, gridOptions){
				gridOptions.exportConfig = {}
			},
			exportpanel(){
				this.$refs[this.moduleName+'_list'].exportData({
					type: 'xlsx'
				})
			},
			uploadinvoice(){
				// navigator.usb.requestDevice({ filters: [] }).then((res)=>{
				// 	console.log(res)
				// })
				
				
				let data =  this.getGrid().getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}
				let supplierwlnids = data.map((item)=>{
					return item.supplierwlnid
				})
				let purchasecodes = data.map((item)=>{
					return item.purchasecode
				})
				supplierwlnids = Array.from(new Set(supplierwlnids))
				if(supplierwlnids.length>1){
					this.$message.error('供应商不能多选')
					return
				}
				//console.log(supplierwlnids)
				this.$api.flow.getSingleFlowTemplate(30).then((e) => {
					if (e) {
						let res = this.$router.resolve({
							name: 'add',
							query: {
								name: 'supplierinvoice',
								id: 0,
								controlltype: 1,
								windowName: '供应商发票',
								extra: JSON.stringify({
									supplierwlnids: supplierwlnids[0],
									purchasecodes: purchasecodes.join(',')
								}),
								isflow: 1,
								flowid: 30
							}
						})
						if (this.device != 'pc') {
							this.$router.push(res.href.replace(/#/g, ''))
						} else {
							let win = window.open(res.href, "supplierinvoiceadd",
								this.$store.state.system.windowConfig)
							win.onload = () => {
								console.log('supplierinvoiceform open')
							}
						}
				
					}
				})
				// this.loading = true
				// let ids = data.map((item)=>{
				// 	return item.id
				// })
				// this.$api.paymentapplication.sendjindie({ids:ids}).then(()=>{
				// 	this.loading = false
				// 	this.customreload()
				// },()=>{
				// 	this.loading = false
				// })
			}
		},
		components: {
			formIndex,
			staticIndex
		}
	}
</script>
